import React from "react";
import classNames from "classnames";
import { getPaymentIcon, sortPaymentMethods } from "./PaymentMethodUtils";
import "./PaymentMethodSelector.less";

export interface PaymentMethodSelectorProps {
  /** 可用的支付方式列表 */
  methods: string[];
  /** 当前选中的支付方式 */
  selectedMethod: string;
  /** 选择支付方式的回调 */
  onMethodSelect: (method: string) => void;
  /** 自定义样式类名 */
  className?: string;
  /** 显示模式：'horizontal' | 'vertical' */
  layout?: "horizontal" | "vertical";
}

const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  methods,
  selectedMethod,
  onMethodSelect,
  className,
  layout = "horizontal",
}) => {
  if (!methods || methods.length === 0) {
    return null;
  }

  const orderedMethods = sortPaymentMethods(methods);

  return (
    <div
      className={classNames(
        "payment-method-selector",
        `layout-${layout}`,
        className
      )}
    >
      {orderedMethods.map((method) => {
        const icon = getPaymentIcon(method);

        return (
          <div
            key={method}
            className={classNames("method-item", {
              active: selectedMethod === method,
            })}
            onClick={() => onMethodSelect(method)}
          >
            {icon && <img src={icon} alt={method} className="method-icon" />}
            <span className="method-text">
              {method.charAt(0).toUpperCase() + method.slice(1)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PaymentMethodSelector;
